import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Acminibusforrouppicnicpune() {



const cardData =
{
  keyword: 'AC Mini Bus for Group Picnic Pune',
  heading: 'Sanavi Travels: AC Mini Bus for Group Picnic Pune',
  headingDescription: 'Sanavi Travels offers reliable and comfortable AC Mini Bus for Group Picnic Pune services, specially designed for families, friends, schools, colleges, and corporate teams planning enjoyable group outings. Our AC mini buses ensure relaxed, safe, and well-coordinated travel for picnics, local tours, sightseeing trips, and short-distance leisure journeys around Pune and nearby destinations.',

  top: 'Best Picnic & Group Travel Experiences from Pune by AC Mini Bus',

  "topPlaces": [
    {
      "title": "Family Picnic Destinations Around Pune",
      "description": "Family picnic spots around Pune such as Sinhagad base areas, Khadakwasla Dam surroundings, Pashan Lake zones, and nearby resorts are ideal for relaxed one-day outings. Hiring an AC mini bus allows families to travel together comfortably without worrying about multiple cars, navigation issues, or parking challenges. With cool interiors, comfortable seating, and sufficient space for food items, picnic mats, and essentials, AC mini bus travel ensures senior citizens, children, and adults enjoy the journey equally. Families can focus on bonding, relaxation, and fun while professional drivers handle traffic, routes, and timing, making the entire picnic experience smooth and stress-free."
    },
    {
      "title": "Corporate Team Picnic Locations",
      "description": "Corporate picnic locations near Pune include resorts, adventure parks, and countryside retreats that are perfect for team bonding and recreation. AC mini buses provide professional and organized transportation for corporate teams, ensuring punctual arrivals and disciplined travel schedules. Employees can travel together, interact during the journey, and start team activities with positive energy. The comfort of air-conditioned travel enhances employee satisfaction, especially during warm weather, and reflects a professional approach to corporate event planning."
    },
    {
      "title": "Friends Group Picnic & Outings",
      "description": "Friends planning group picnics or casual outings prefer AC mini buses as they are cost-effective, fun, and convenient. Traveling together allows groups to enjoy music, conversations, and shared moments throughout the journey. AC mini buses eliminate the hassle of coordinating multiple vehicles and ensure everyone reaches the destination together. Spacious seating, cooling comfort, and smooth rides turn the journey itself into a memorable part of the picnic experience."
    },
    {
      "title": "School & College Picnic Trips",
      "description": "School and college picnic trips require safe, disciplined, and comfortable transportation. AC mini buses are ideal for student groups as they provide controlled environments, professional drivers, and reliable scheduling. Educational institutions benefit from organized group travel that prioritizes student safety, comfort, and punctuality. Air-conditioned travel keeps students comfortable and energetic, ensuring they enjoy the picnic or educational tour without travel fatigue."
    },
    {
      "title": "Sightseeing & Local Tours",
      "description": "Local sightseeing tours around Pune, including heritage sites, nature spots, and cultural attractions, are best enjoyed through group travel. AC mini buses support relaxed sightseeing by offering comfortable travel between multiple locations in a single day. Passengers can enjoy consistent cooling, comfortable seating, and planned stops, making local tours enjoyable for tourists, families, and corporate guests alike."
    },
    {
      "title": "Resort & Farm Stay Day Trips",
      "description": "Resort and farm stay day trips are popular choices for group picnics near Pune. AC mini buses ensure timely arrival and departure, helping groups make the most of their leisure time. Travelers arrive refreshed and ready to enjoy activities, meals, and relaxation without the fatigue of driving or coordinating multiple vehicles."
    },
    {
      "title": "Wedding Picnic & Pre-Event Outings",
      "description": "Wedding-related picnics, pre-wedding outings, and family gatherings often involve group travel. AC mini buses provide elegant and comfortable transport for wedding guests, ensuring everyone travels together and reaches destinations on time. This organized approach reduces logistical stress during busy wedding schedules."
    },
    {
      "title": "Corporate Training & Fun Day Trips",
      "description": "Companies organizing training sessions combined with fun day picnics prefer AC mini buses for their flexibility and comfort. Employees can travel together, maintain schedules, and enjoy air-conditioned comfort, which enhances overall participation and satisfaction during corporate outings."
    },
    {
      "title": "Senior Citizen Group Picnics",
      "description": "Senior citizen groups require extra comfort and care during travel. AC mini buses provide easy boarding, comfortable seating, and cool interiors, making short trips and picnics pleasant and safe for elderly travelers. Professional drivers ensure smooth driving and considerate handling of routes."
    },
    {
      "title": "Customized Picnic & Group Routes",
      "description": "Many groups prefer customized picnic routes and timings based on their preferences. AC mini bus rentals offer flexibility in planning routes, pickup points, and schedules, ensuring a personalized travel experience that suits the group’s needs perfectly."
    }
  ],

  "services": [
    {
      "name": "AC Mini Bus for Group Picnic Pune",
      "description": "Sanavi Travels provides dedicated AC mini bus services for group picnics in Pune, offering a perfect balance of comfort, safety, and affordability. Our AC mini buses are ideal for families, friends, corporate teams, schools, and social groups planning picnic trips, sightseeing tours, or leisure outings. With clean interiors, efficient air-conditioning, comfortable seating, and ample space for picnic supplies, our service ensures a relaxed journey. Professional drivers handle navigation, traffic, and timing, allowing groups to focus on enjoyment. Flexible packages, transparent pricing, and reliable support make our AC mini bus picnic service a preferred choice for organized group travel."
    },
    {
      "name": "12 Seater AC Mini Bus Pune",
      "description": "12 seater AC mini buses are perfect for small families and compact groups planning picnic trips or local tours. These buses offer easy maneuverability, efficient cooling, and cost-effective travel while maintaining comfort and safety throughout the journey."
    },
    {
      "name": "16 Seater AC Mini Bus Pune",
      "description": "16 seater AC mini buses suit medium-sized groups such as extended families, friends, or small corporate teams. They provide balanced seating capacity, comfortable interiors, and reliable performance for short-distance picnic travel."
    },
    {
      "name": "20 Seater AC Mini Bus Pune",
      "description": "20 seater AC mini buses are ideal for larger picnic groups, school outings, and corporate events. With spacious seating and consistent cooling, they ensure everyone travels together comfortably and arrives refreshed."
    },
    {
      "name": "Luxury AC Mini Bus Pune",
      "description": "Luxury AC mini buses feature upgraded interiors, enhanced seating comfort, and premium finishes. These buses are suitable for high-end picnics, corporate guests, and special group outings where comfort and presentation matter."
    },
    {
      "name": "AC Mini Bus for Family Picnic Pune",
      "description": "Family picnic mini bus services prioritize safety, comfort, and convenience for travelers of all ages. Families can relax together during the journey, enjoy air-conditioned comfort, and reach picnic spots stress-free."
    },
    {
      "name": "AC Mini Bus for Corporate Picnic Pune",
      "description": "Corporate picnic travel requires punctuality and professionalism. AC mini buses provide disciplined transport, ensuring employees travel together comfortably and reach destinations on time."
    },
    {
      "name": "AC Mini Bus for Group Travel Pune",
      "description": "Group travel mini buses are designed to accommodate diverse groups with varying needs. From friends’ outings to social events, these buses ensure coordinated, enjoyable, and efficient travel."
    },
    {
      "name": "Affordable AC Mini Bus Hire Pune",
      "description": "Affordable AC mini bus rental options help groups plan picnic trips within budget without compromising on comfort or reliability. Transparent pricing ensures cost control and peace of mind."
    },
    {
      "name": "Best AC Mini Bus Service Pune",
      "description": "Sanavi Travels is recognized for dependable AC mini bus services in Pune, offering consistent quality, customer satisfaction, and well-managed group travel experiences."
    },
    {
      "name": "AC Mini Bus with Driver Pune",
      "description": "All AC mini buses come with experienced and courteous drivers who ensure safe driving, route familiarity, and timely travel for picnic and group trips."
    },
    {
      "name": "AC Mini Bus for Wedding Pune",
      "description": "Wedding-related picnic and outing travel is simplified with AC mini bus services that manage guest transportation efficiently and comfortably."
    },
    {
      "name": "AC Mini Bus for Sightseeing Pune",
      "description": "Sightseeing mini bus services support relaxed travel between multiple locations, allowing groups to enjoy attractions without transport worries."
    },
    {
      "name": "AC Mini Bus for Picnic Pune",
      "description": "Dedicated picnic mini bus services ensure smooth group movement, ample space, and comfortable travel for enjoyable leisure outings."
    },
    {
      "name": "AC Mini Bus for Local Tour Pune",
      "description": "Local tour mini bus rentals provide convenient transportation for exploring Pune and nearby areas in a single day with comfort and flexibility."
    }
  ],

  "tableData": [
    ["AC Mini Bus", "Group Picnic"],
    ["12 Seater", "16 Seater"],
    ["20 Seater", "Luxury Mini Bus"],
    ["Family Picnic", "Corporate Picnic"],
    ["Sightseeing", "Local Tours"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Comfortable AC Travel", "WhyChoosedescription": "Air-conditioned buses ensure relaxed group journeys." },
    { "WhyChooseheading": "Experienced Drivers", "WhyChoosedescription": "Professional drivers familiar with picnic routes." },
    { "WhyChooseheading": "Flexible Packages", "WhyChoosedescription": "Custom plans for different group needs." },
    { "WhyChooseheading": "Safe & Clean Buses", "WhyChoosedescription": "Well-maintained and hygienic vehicles." },
    { "WhyChooseheading": "Affordable Pricing", "WhyChoosedescription": "Budget-friendly options with transparent costs." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "On-Time Service", "WhyChoosedescription": "Punctual pickups and drop-offs." },
    { "WhyChooseheading": "Trusted Provider", "WhyChoosedescription": "Sanavi Travels is trusted across Pune." }
  ]
};

const faqData = [
  { question: 'Do you provide AC mini buses for group picnics in Pune?', answer: 'Yes, Sanavi Travels offers AC mini buses for group picnic travel in Pune.' },
  { question: 'What seating options are available?', answer: '12, 16, and 20 seater AC mini buses are available.' },
  { question: 'Are drivers included with the bus?', answer: 'Yes, all buses come with experienced drivers.' },
  { question: 'Is the service suitable for corporate picnics?', answer: 'Yes, corporate picnic and team outings are supported.' },
  { question: 'Can families book AC mini buses?', answer: 'Yes, family picnic travel is a popular use case.' },
  { question: 'Are luxury AC mini buses available?', answer: 'Yes, luxury options are offered.' },
  { question: 'Is pricing transparent?', answer: 'Yes, pricing is clear with no hidden charges.' },
  { question: 'Can we customize pickup points?', answer: 'Yes, pickups and routes can be customized.' },
  { question: 'Are buses suitable for sightseeing?', answer: 'Yes, they are ideal for sightseeing and local tours.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended for availability.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'Booked an AC mini bus for our family picnic. Very comfortable and well-managed.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Great service for our corporate picnic. Clean bus and professional driver.',
    rating: 5
  }
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Mini Bus for Group Picnic Pune - Sanavi Travels",
  "description": "Sanavi Travels provides AC mini buses for group picnics in Pune, including 12-seater, 16-seater, 20-seater, and luxury options. Perfect for family outings, corporate trips, group travel, weddings, sightseeing, and local tours with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | AC Mini Bus for Group Picnic Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC mini buses for group picnics in Pune with Sanavi Travels. 12, 16, 20-seater and luxury mini buses for family outings, corporate trips, weddings, sightseeing, and local tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/294.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Acminibusforrouppicnicpune;